
import { Mail, MapPin, Copyright, FileText, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between text-sm text-gray-600 mb-4">
          <div className="flex items-center mb-2 md:mb-0">
            <Copyright className="w-4 h-4 mr-1 text-wamy-600" /> 
            <span>{currentYear} Wamy AI, Inc. All rights reserved.</span>
          </div>
          
          <div className="flex flex-col md:flex-row md:space-x-6">
            <div className="flex items-start mb-1 md:mb-0">
              <MapPin className="w-4 h-4 text-wamy-600 mt-0.5 mr-1 flex-shrink-0" />
              <span>915 Biscayne Blvd Suite 300, Miami, FL 33137</span>
            </div>
            
            <div className="flex items-center">
              <Mail className="w-4 h-4 text-wamy-600 mr-1 flex-shrink-0" />
              <a href="mailto:info@wamy.com" className="hover:text-wamy-600 transition-colors">
                info@wamy.com
              </a>
            </div>
          </div>
        </div>
        
        {/* Legal Links */}
        <div className="border-t border-gray-200 pt-4">
          <ul className="flex flex-wrap gap-x-6 gap-y-2 justify-center text-xs text-gray-500">
            <li>
              <Link to="/terms-and-conditions" className="flex items-center hover:text-wamy-600 transition-colors">
                <FileText className="w-3 h-3 mr-1" /> Terms and Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="flex items-center hover:text-wamy-600 transition-colors">
                <FileText className="w-3 h-3 mr-1" /> Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/cookies-policy" className="flex items-center hover:text-wamy-600 transition-colors">
                <Cookie className="w-3 h-3 mr-1" /> Cookies Policy
              </Link>
            </li>
            <li>
              <Link to="/disclaimer" className="flex items-center hover:text-wamy-600 transition-colors">
                <FileText className="w-3 h-3 mr-1" /> Disclaimer
              </Link>
            </li>
            <li>
              <Link to="/acceptable-use-policy" className="flex items-center hover:text-wamy-600 transition-colors">
                <FileText className="w-3 h-3 mr-1" /> Acceptable Use Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
